<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface HowItWorksProps {
  badgeTitle: string;
  title: string;
  description: string;
  image: string;
}

const HowItWorksList: HowItWorksProps[] = [
  {
    badgeTitle: "需求分析",
    title: "深度了解客户需求，定制化解决方案",
    description:
      "专业团队与客户深入沟通，全面分析业务场景和技术需求，制定最适合的物联网+AI解决方案，确保项目成功实施。",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop",
  },
  {
    badgeTitle: "方案设计",
    title: "技术架构设计，系统规划部署",
    description:
      "基于需求分析结果，设计完整的技术架构方案，包括硬件选型、软件开发、数据流设计，为项目实施提供详细蓝图。",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop",
  },
  {
    badgeTitle: "实施部署",
    title: "专业团队实施，确保项目质量",
    description:
      "经验丰富的工程师团队负责系统实施部署，严格按照方案执行，实时监控项目进度，保证系统稳定运行。",
    image: "https://images.pexels.com/photos/1089440/pexels-photo-1089440.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  {
    badgeTitle: "运维支持",
    title: "持续优化服务，保障系统稳定",
    description:
      "提供7x24小时技术支持，定期系统维护和性能优化，确保客户系统长期稳定运行，持续创造业务价值。",
    image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=400&h=300&fit=crop",
  },
];
</script>

<template>
  <section
    id="features"
    class="container py-24 sm:py-32"
  >
    <div class="text-center mb-8">
      <h2 class="text-lg text-primary text-center mb-2 tracking-wider">
        物联网+AI项目服务流程
      </h2>

      <h2 class="text-3xl md:text-4xl text-center font-bold">
        工业自动化专业服务 · 智能化实施步步为营
      </h2>
    </div>

    <div class="lg:w-[80%] mx-auto relative">
      <div
        v-for="(
          { badgeTitle, title, description, image }, index
        ) in HowItWorksList"
        :key="title"
        :class="[
          'flex mb-8 items-center',
          { ' flex-row-reverse': index % 2 !== 0 },
        ]"
      >
        <Card class="h-full bg-transparent border-0 shadow-none">
          <CardHeader>
            <div class="pb-4">
              <Badge>{{ badgeTitle }}</Badge>
            </div>

            <CardTitle>
              {{ title }}
            </CardTitle>
          </CardHeader>

          <CardContent class="text-muted-foreground w-[80%]">
            {{ description }}
          </CardContent>
        </Card>

        <img
          :src="image"
          :alt="`物联网+AI项目${badgeTitle}阶段 - 工业自动化${title}服务流程示意图`"
          class="w-[150px] md:w-[250px] lg:w-[300px] mx-auto -scale-x-100"
          loading="lazy"
          :width="300"
          :height="225"
        />
        <div
          :class="[
            '-z-10 absolute right-0 w-44 h-72  lg:w-64 lg:h-80 rounded-full bg-primary/15 dark:bg-primary/10 blur-3xl',
            {
              'left-0': index % 2 !== 0,
            },
          ]"
        ></div>
      </div>
    </div>
  </section>
</template>
